module.exports = __webpack_public_path__ + "static/media/logo_kuppi_wo_slogan.f2356d52.png";